var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.user.avatar)?_c('b-avatar',{style:('background-color:' + _vm.userColor),attrs:{"text":_vm.shortUName}}):_c('b-avatar',{attrs:{"src":_vm.getAvatar(_vm.user.avatar)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }